import React, { useCallback, useState } from 'react';

import { Button, TextArea } from '@components/common';

import { MAX_DESCRIPTION_LENGTH } from '@constants/validationMessages';

import styles from './RequestActionConfirmationModal.module.scss';

const textAreaRows = 4;

export type TOnApprove = (comments?: string) => void;

interface IRequestActionConfirmationModal {
	closeModal: () => void;
	onApprove: TOnApprove;
	acceptButtonTitle: string;
	description?: string;
	isCommentRequired?: boolean;
	cancelButtonTitle?: string;
	placeholder?: string;
	label?: string;
	isWithoutComments?: boolean;
}

function RequestActionConfirmationModal({
	closeModal,
	onApprove,
	acceptButtonTitle,
	description,
	isCommentRequired,
	cancelButtonTitle,
	placeholder,
	label,
	isWithoutComments = false,
}: IRequestActionConfirmationModal) {
	const [comments, setComments] = useState('');

	const handleChange = useCallback((value: string) => {
		if (value?.length > MAX_DESCRIPTION_LENGTH) return;

		setComments(value);
	}, []);

	const handleApprove = () => {
		onApprove(comments);
	};

	return (
		<div>
			{description && <div className={styles.description}>{description}</div>}
			{!isWithoutComments
				&& <TextArea
					label={label || 'Comments'}
					name='comments'
					onChange={handleChange}
					placeholder={placeholder || 'Leave comment'}
					required={isCommentRequired}
					rows={textAreaRows}
					value={comments}
				/>
			}
			<div className={styles.buttonsContainer}>
				<Button className={styles.cancelBtn}
						onClick={closeModal}
						text={cancelButtonTitle || 'Cancel'}
						withoutBackground
				/>
				<Button
					disabled={isCommentRequired && !comments.length}
					onClick={handleApprove}
					text={acceptButtonTitle}
				/>
			</div>
		</div>
	);
}

export default RequestActionConfirmationModal;
